module.exports = "/_next/static/images/favicon-56c85f9cc76e615ac529891aaec6c9f5.png";